import { useEffect } from 'react';

import { createGenerateId, JssProvider, SheetsRegistry } from 'react-jss';
import { Spacings, withTabFocus } from '@picsart/cascade';
import { View } from '@picsart/view';
import { Loader } from '@picsart/loader';

import Main from './components/Main';
import useStyles from './useStyles';
import useThemeChange from './hooks/useThemeChange';
import useOpen from './hooks/useOpen';
import noop from './utils/noop';

import { IS_DEV } from './constants';

const registry = new SheetsRegistry();
const generateId = createGenerateId({ minify: false });

const App = () => {
  useStyles();

  useEffect(() => {
    withTabFocus();
  }, []);

  useThemeChange();

  const isOpen = useOpen(noop);

  return (
    <JssProvider generateId={generateId} registry={registry}>
      {isOpen ? (
        <View {...(!IS_DEV ? { marginInline: Spacings.s16 } : {})}>
          <Main />
        </View>
      ) : (
        <Loader />
      )}
    </JssProvider>
  );
};

export default App;
